import { Chip, Stack } from '@mui/material';
import { EmptyValue } from 'src/graphql/entities/custom-attributes/field-view-registry/components/empty-value';
import { CustomAttributeReadProps } from 'src/graphql/entities/custom-attributes/field-view-registry/types';
import {
  getAttributeOptionLabel,
  getKindLikeValueSafely,
} from 'src/graphql/entities/custom-attributes/field-view-registry/utils';

export const MultiSelectView = ({ value, definition }: CustomAttributeReadProps) => {
  const selectedList = getKindLikeValueSafely(value, 'multi_select') ?? [];

  if (selectedList.length === 0) {
    return <EmptyValue />;
  }

  return (
    <Stack direction="row" gap={0.5} flexWrap="wrap" minWidth={0} width="100%">
      {selectedList.map((key) => (
        <Chip
          key={key}
          label={getAttributeOptionLabel(definition.options, key)}
          size="small"
          sx={{ fontSize: '0.7rem', height: '1.25rem' }}
        />
      ))}
    </Stack>
  );
};
